var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExperience(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.61906 14.262V5.35718H14.5715V8.02053C15.1544 8.19862 15.7049 8.45767 16.1906 8.80577V5.35718C16.1906 4.4586 15.4701 3.73812 14.5715 3.73812H11.3334V2.11906C11.3334 1.22048 10.6129 0.5 9.71435 0.5H6.47623C5.57766 0.5 4.85718 1.22048 4.85718 2.11906V3.73812H1.61906C0.720481 3.73812 0.00809528 4.4586 0.00809528 5.35718L0 14.262C0 15.1606 0.720481 15.8811 1.61906 15.8811H7.83624C7.59339 15.3792 7.43148 14.8368 7.35053 14.262H1.61906ZM6.47623 2.11906H9.71435V3.73812H6.47623V2.11906Z",
    fill: "#787878"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9522 9.40479C10.7179 9.40479 8.90454 11.2181 8.90454 13.4524C8.90454 15.6867 10.7179 17.5001 12.9522 17.5001C15.1865 17.5001 16.9998 15.6867 16.9998 13.4524C16.9998 11.2181 15.1865 9.40479 12.9522 9.40479ZM14.2879 15.3548L12.5474 13.6143V11.0238H13.357V13.2824L14.8546 14.7801L14.2879 15.3548Z",
    fill: "#787878"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExperience);
export default __webpack_public_path__ + "static/media/experience.b588c5029866a052bb155073b2cbcd0c.svg";
export { ForwardRef as ReactComponent };